import {Button, Dialog, DialogContent, DialogTitle, Grid, MenuItem, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography} from "@mui/material";
import axios from "axios";
import * as React from "react";
import {v4 as uuidv4} from "uuid";
import {Config} from "../../config/config";
import {Helpers} from "../../utils/helpers";
import {PopupMessage} from "../../utils/message";

const operators = [
    ">", "<", "=", ">=", "<="
];


export class VerifyBuildings extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            loading: false,
            filter: {
                operator: "=",
                hqLevel: 4,
                offset: 0,
                limit: 1
            },
            data: {
                amount: 0,
                brokenUsers: [],
            },
            timer: {
                component: null,
                run: false,
                tick: 0,
                interval: 1000,
            }
        };
    }

    componentDidMount(): void {
        this.getAmount();
    }

    componentWillUnmount(): void {
        clearInterval(this.state.timer.component);
    }

    startTimer = () => {
        const {timer} = this.state;

        if (timer.run) {
            return;
        }

        timer.tick = 0;

        const component = setInterval(() => {
            const {timer} = this.state;

            timer.tick += 1;

            this.setState({timer});
        }, timer.interval);

        timer.run = true;
        timer.component = component;

        this.setState({timer});
    }

    stopTimer = () => {
        const {timer} = this.state;

        if (!timer.run) {
            return;
        }

        clearInterval(timer.component);

        timer.run = false;
        // timer.tick = 0;

        this.setState({timer});
    }

    onLoading = () => {
        this.setState({loading: true});

        this.startTimer();
    }

    onLoaded = () => {
        this.setState({loading: false});

        this.stopTimer();
    }

    getAmount = async () => {
        const url = `${Config.getInstance.apiUrl}/api/users/user_amount_by_hq`;

        const {filter} = this.state;

        const body = filter;

        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        this.onLoading();

        const response = await axios.post(url, body, {headers});

        const data = response.data;
        const success = data.success;

        if (success) {
            const total = data.amount;
            const stateData = this.state.data;

            stateData.amount = total;

            this.setState({
                loading: false,
                data: stateData
            });

            this.onLoaded();
        } else {
            PopupMessage.error("Failed to get amount")
        }
    }

    onChangeFilter(key: string, value: any) {
        const {filter} = this.state;
        filter[key] = value;
        
        this.setState({filter});

        if (key === "hqLevel") {
            this.getAmount();
        }
    }

    verifyBuilding = async () => {
        const url = `${Config.getInstance.apiUrl}/api/users/verify_buildings`;
        const {filter} = this.state;

        const body = filter;

        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        this.onLoading();

        const response = await axios.post(url, body, {headers});

        const data = response.data;
        const success = data.success;

        if (success) {
            const total = data.total;
            const brokenUsers = data.brokenUsers;

            this.setState({
                loading: false,
                data: {
                    amount: total,
                    brokenUsers: brokenUsers
                }
            });

            this.onLoaded();
        } else {
            PopupMessage.error("Failed to verify buildings")
        }
    }

    copyToClipboard(text: string) {
        navigator.clipboard.writeText(text);

        PopupMessage.success("Copied to clipboard");
    }

    renderTimer = () => {
        // Count up timer
        const {timer} = this.state;
        const tick = timer.tick;

        // Format to MM:SS
        const str = `${Math.floor(tick / 60)}:${tick % 60}`;

        if (timer.tick === 0) {
            return <div></div>
        }

        return <div>
            <Typography variant="h6">Timer: {str}</Typography>
        </div>
    }

    renderFilter = () => {
        const {filter} = this.state;

        return <Paper style={{width: "100%"}}>
            <Typography variant="h6">Filter</Typography>
            <Grid container spacing={2}>
                <Grid item container sm={12} spacing={2}>
                    <Grid item xs={2}>
                        <TextField
                            select
                            label="Operator"
                            value={filter.operators}
                            onChange={(e) => this.setState({filter: {...filter, operators: e.target.value}})}
                            fullWidth
                        >
                            {operators.map((option) => (
                                <MenuItem key={uuidv4()} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            label="HQ Level"
                            value={filter.hqLevel}
                            onChange={(e) => this.onChangeFilter("hqLevel", e.target.value)}
                            fullWidth
                        />
                    </Grid>
                </Grid>

                <Grid item container sm={12} spacing={2} justifyContent={"flex-end"}>
                    <Grid item xs={2}>
                        <TextField
                            label="Offset"
                            value={filter.offset}
                            onChange={(e) => this.setState({filter: {...filter, offset: e.target.value}})}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            label="Limit"
                            value={filter.limit}
                            onChange={(e) => this.setState({filter: {...filter, limit: e.target.value}})}
                            fullWidth
                        />
                    </Grid>
                    <Grid item sm={2}>
                        <Button variant="contained" color="primary" onClick={this.verifyBuilding}>Verify</Button>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    }

    renderContent = () => {
        const {data} = this.state;
        const brokenUsers = data.brokenUsers;

        if (brokenUsers.length === 0) {
            return <Typography variant="h6">No broken buildings found</Typography>
        }

        // brokenUsers = [{userId, username, hqLevel, brokenBuildings: [{buildingId, amount, limit}]}]

        return <Paper style={{width: "100%"}}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Uid</TableCell>
                        <TableCell>Username</TableCell>
                        <TableCell>HQ</TableCell>
                        <TableCell>Broken Buildings</TableCell>
                        <TableCell>Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {brokenUsers.map((user: any, index: number) => {
                        const {userId, username, hqLevel, brokenBuildings} = user;

                        return <TableRow key={uuidv4()}>
                            <TableCell>{userId}</TableCell>
                            <TableCell>{username}</TableCell>
                            <TableCell>{hqLevel}</TableCell>
                            <TableCell>
                                {JSON.stringify(brokenBuildings)}
                            </TableCell>
                            <TableCell>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => this.copyToClipboard(JSON.stringify(user))}
                                >Copy</Button>
                            </TableCell>
                        </TableRow>
                    })}
                </TableBody>
            </Table>
        </Paper>
    }

    render = () => {
        const {loading} = this.state;

        if (loading) {
            return <Paper className="contentPadding" style={{width: "100%"}}>
                <Typography variant="h4">Verify buildings: </Typography>
                <Typography variant="h6">Loading...</Typography>
                {this.renderTimer()}
            </Paper>
        }

        return <Paper className="contentPadding" style={{width: "100%"}}>
            <Typography variant="h4">Verify buildings: </Typography>
            <Typography variant="h6">User Amount For HQ {this.state.filter.hqLevel} = {this.state.data.amount} </Typography>
            {this.renderTimer()}
            {this.renderFilter()}
            {this.renderContent()}
        </Paper>
    }
}